const uiPoint = 5

module.exports = {
  uiPoint,
  gridMaxMobileWidth: 550,
  gridMaxMiddleWidth: 940,
  gridMaxWideWidth: 1120,
  gridGutterWidth: 20,
}
